var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoDepositsTaxes = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Deposits",
    transform: "translate(-26.289 -77.833)",
    fill: "#00a1af"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48490",
    "data-name": "Path 48490",
    d: "M27.577,85.446a1.254,1.254,0,0,0,0,2.507h2.571a8.009,8.009,0,0,1,.9-2.507Z",
    transform: "translate(.008 .842)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48491",
    "data-name": "Path 48491",
    d: "M35.7,81.405H30.594a1.254,1.254,0,0,0,0,2.507h1.453A7.956,7.956,0,0,1,35.7,81.405Z",
    transform: "translate(.338 .395)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48491-2",
    "data-name": "Path 48491",
    d: "M43.649,83.912h0a1.254,1.254,0,0,0,0-2.507H39.222A7.078,7.078,0,0,1,43.649,83.912Z",
    transform: "translate(1.42 .395)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48493",
    "data-name": "Path 48493",
    d: "M27.577,77.833a1.272,1.272,0,0,0,0,2.542H40.139a1.272,1.272,0,0,0,0-2.542Z",
    transform: "translate(.008)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48494",
    "data-name": "Path 48494",
    d: "M30.046,89.506H27.577a1.254,1.254,0,0,0,0,2.507h3.069A5.733,5.733,0,0,1,30.046,89.506Z",
    transform: "translate(.008 1.291)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48495",
    "data-name": "Path 48495",
    d: "M27.585,96.093H33.82a8.037,8.037,0,0,1-2.387-2.543H27.585a1.272,1.272,0,0,0-.075,2.543C27.535,96.095,27.561,96.095,27.585,96.093Z",
    transform: "translate(0 1.738)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M45.732,89.16a6.96,6.96,0,0,0-3.87-5.57,7.3,7.3,0,0,0-9.679,3,7,7,0,0,0-.759,2.571,6.465,6.465,0,0,0-.02,1,6.956,6.956,0,0,0,.779,2.83l.154.27a1.44,1.44,0,0,1,.081.139c.061.1.134.2.2.3.061.08.114.159.175.239l.041.05a7.261,7.261,0,0,0,3.581,2.462l.041.01a2.841,2.841,0,0,0,.278.08l.164.039a2,2,0,0,0,.226.05c.134.03.256.049.39.07a.709.709,0,0,1,.154.02l.319.029.144.01c.144.01.3.01.454.01s.3,0,.452-.01l.145-.01.308-.029a.718.718,0,0,1,.154-.02c.134-.021.267-.04.39-.07.081-.02.154-.03.235-.05l.165-.039q.14-.033.278-.08l.041-.01a7.239,7.239,0,0,0,3.571-2.462l.041-.05c.05-.079.113-.158.174-.239.061-.1.134-.2.2-.3.03-.049.051-.1.081-.139l.154-.27a6.823,6.823,0,0,0,.794-2.83A6.466,6.466,0,0,0,45.732,89.16ZM40.416,92.4a2.323,2.323,0,0,1-1.263.538v1.215h-1.02v-1.2a3.665,3.665,0,0,1-1.037-.149c-.226-.07-.441-.148-.658-.24l-.081-.049.309-.917.1.05a5.823,5.823,0,0,0,.688.25,3.872,3.872,0,0,0,.954.1,1.756,1.756,0,0,0,1-.22.609.609,0,0,0,.256-.5.62.62,0,0,0-.114-.4,1.506,1.506,0,0,0-.319-.3,4.488,4.488,0,0,0-.483-.25c-.2-.079-.4-.149-.584-.208-.155-.06-.309-.119-.454-.179l-.144-.06a2.95,2.95,0,0,1-.534-.329,1.472,1.472,0,0,1-.39-.478,1.343,1.343,0,0,1-.154-.688,1.578,1.578,0,0,1,.454-1.176,2.065,2.065,0,0,1,1.17-.557v-1.13h1.02V86.6a5.556,5.556,0,0,1,.718.1c.278.07.483.129.6.169l.1.029-.246.946L40.19,87.8c-.184-.06-.379-.12-.574-.169a3.882,3.882,0,0,0-.841-.089,1.643,1.643,0,0,0-.843.2.608.608,0,0,0-.267.528.571.571,0,0,0,.082.319.593.593,0,0,0,.235.24,2.481,2.481,0,0,0,.4.208c.081.03.174.07.267.1s.174.06.267.1c.255.09.493.2.728.3a2.385,2.385,0,0,1,.616.379,1.632,1.632,0,0,1,.442.547,1.513,1.513,0,0,1,.164.758,1.575,1.575,0,0,1-.451,1.18Z",
    transform: "translate(.523 .508)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoDepositsTaxes);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_deposits_taxes.fea2ef7a1644f53e9bc0fa3561c8ed69.svg";